module.exports = __webpack_public_path__ + "static/img/4_1_9.f447ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_9.png
// module id = FG7A
// module chunks = 1